import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class PurchasePartTypeService {
    constructor(http) {
        this.http = http;
        this.singular = 'purchase part type';
        this.plural = 'purchase part types';
        this.editor = PLATFORM.moduleName('pages/system-fields/purchase-part-types/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`purchase-part-types/filter/${loadOptions}`);
        return await response.json();
    }

    async create(purchasePartType) {
        await this.http.fetch('purchase-part-types', { method: 'POST', body: json(purchasePartType) });
    }

    async update(purchasePartType) {
        await this.http.fetch(`purchase-part-types/${purchasePartType.id}`, { method: 'PUT', body: json(purchasePartType) });
    }

    async delete(id) {
        await this.http.fetch(`purchase-part-types/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`purchase-part-types/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`purchase-part-types/top-three/${query}`);
        return await response.json();
    }
}